
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glacier-classic-portable-refrigerator/bundles",
      function () {
        return require("private-next-pages/glacier-classic-portable-refrigerator/bundles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glacier-classic-portable-refrigerator/bundles"])
      });
    }
  